export const OfferListUat = {
  selectOffer: 'offerView.selectOffer',
  nextButton: 'offerView.nextButton',
  completeLaterButton: 'offerView.completeLaterButton'
}
